import React from 'react';
import { FormattedMessage as Translation } from 'react-intl';

const ONE_PAGE_CHECKOUT_EXP = {
    olxin: 'ROAD-32640',
    olxid: 'ROAD-32650',
    olxco: '',
    olxtr: 'ROAD-64035',
    olxpe: '',
    olxec: '',
    olxar: '',
    olxmx: 'ROAD-61728'
};

const ONE_PAGE_CHECKOUT_ENTICEMENT_EXP = {
    olxin: 'ROAD-75799',
    olxid: 'ROAD-75800',
    olxco: '',
    olxtr: 'ROAD-75801',
    olxpe: '',
    olxec: '',
    olxar: '',
    olxmx: 'ROAD-75802'
};

const RADIUS_CHANGE_EXP = {
    olxin: 'ROAD-63992',
    olxid: '',
    olxco: '',
    olxtr: '',
    olxpe: '',
    olxec: '',
    olxar: ''
};

const NON_SERVICEABLE_CENTER_SUGGESTION = {
    olxin: 'ROAD-76730',
    olxid: '',
    olxco: '',
    olxtr: '',
    olxpe: '',
    olxec: '',
    olxar: ''
};

const CAR_DETAILS_CONSTANTS = {
    VALUATION_USER_VALUES: 'valuationUserValues',
    VALUATION_PRIDICTED_PRICE: 'valuationPredictedPrice',
    LEAD_ID: 'lead_id',
    NINETY: 90,
    SIXTY: 60,
    PHONE_KEY: 'phone',
    MAKE_KEY: 'make',
    MILEAGE_KEY: 'mileage',
    VARIANT_KEY: 'variant',
    TRIM_KEY: 'trim',
    YEAR_KEY: 'year',
    REGISTERED_STATE_KEY: 'registeredState',
    AREA_KEY: 'area',
    AUTOS_VALUATION_ROUTE: '/sell-car',
    DISPLAY_VALUE: 'displayValue',
    VALUATION_CROSS_ROUTE: '/',
    VALUATION_FLOW: '/valuation-flow'
};

const VALUATION_TRACKING_EVENTS = {
    name: {
        VALUATION_PAGE_OPEN: 'valuation_page_open',
        VALUATION_BACK_PRESS: 'valuation_tap_back',
        VALUATION_CROSS_PRESS: 'valuation_tap_close',
        VALUATION_ATTRIBUTE_SELECT: 'valuation_attribute_select',
        VALUATION_ATTRIBUTE_COMPLETE: 'valuation_attribute_complete',
        VALUATION_VALUE_CAR: 'valuation_tap_value_my_car',
        VALUATION_ERROR_SHOWN: 'valuation_error_shown',
        VALUATION_CLOSE_DROPDOWN: 'valuation_tap_close_dropdown',
        VALUATION_PRICES_SHOWN: 'valuation_prices_shown',
        VALUATION_LEAD_CREATED: 'valuation_lead_created'
    },
    origin: {
        val: 'homepage_widget' // Todo:- need to drive this from REDUX
    },
    flow: {
        old: 'instant_sell_new_booking_draft',
        'new': 'instant_sell_new_booking_no_draft'
    },
    page: {
        carDetails: 'valuation_car_details',
        carDetailsFilled: 'valuation_car_details_filled'
    },
    field: {
        bookingIndexId: 'booking_index_id'
    }
};

const staticHeading = {
    make: <Translation id="make" />,
    model: <Translation id="model" />,
    variant: <Translation id="variant" />,
    registeredState: <Translation id="registeredState" />,
    year: <Translation id="year" />,
    first_owner: <Translation id="first_owner" />,
    mileage: <Translation id="mileage" />,
    phone: <Translation id="login_sms_enter_phone_number" />
};

const OPC_EXP_QUOTE_PAGE = {
    olxin: '',
    olxid: '',
    olxmx: '',
    olxcl: '',
    olxco: '',
    olxtr: 'ROAD-64035',
    olxar: ''
};

const SINGLE_PRICE_QUOTE_EXP = {
    olxin: '',
    olxid: '',
    olxmx: 'ROAD-74984',
    olxcl: '',
    olxco: '',
    olxtr: '',
    olxar: ''
};

const SINGLE_PRICE_WIDGET_OMIT = {
    olxin: [],
    olxid: [],
    olxmx: ['mx-desktop-valuation-done-split-view-revamp-single-price', 'book_appointment_desktop_price_estimation_revamp-single-price'],
    olxcl: [],
    olxco: [],
    olxtr: [],
    olxar: []
};

const MULTI_PRICE_WIDGET_OMIT = {
    olxin: [],
    olxid: [],
    olxmx: ['mx-desktop-valuation-done-split-view-revamp', 'book_appointment_desktop_price_estimation_revamp'],
    olxcl: [],
    olxco: [],
    olxtr: [],
    olxar: []
};

const MARKETING_CAMPAIGNS_MAPPING = ['fbclid', 'tbclid', 'gclid', 'msclkid', 'twclid', 'tbclid', 'tbcli'];

const WIDGET_OMIT_QUOTE_PAGE = 'mobile_book_app_home_visit';

export {
    CAR_DETAILS_CONSTANTS,
    VALUATION_TRACKING_EVENTS,
    staticHeading,
    ONE_PAGE_CHECKOUT_EXP,
    MARKETING_CAMPAIGNS_MAPPING,
    RADIUS_CHANGE_EXP,
    NON_SERVICEABLE_CENTER_SUGGESTION,
    OPC_EXP_QUOTE_PAGE,
    WIDGET_OMIT_QUOTE_PAGE,
    SINGLE_PRICE_QUOTE_EXP,
    MULTI_PRICE_WIDGET_OMIT,
    SINGLE_PRICE_WIDGET_OMIT,
    ONE_PAGE_CHECKOUT_ENTICEMENT_EXP
};

export const CAMPAIGN_DATA = 'campaignData';

export const NUMBER_PLATE_REGEX_VALIDATOR = /((^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TN|TS|TR|UA|UK|UP|WB)[0-9][0-9][A-Z]{2}[0-9]{4})|(^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TN|TS|TR|UA|UK|UP|WB)[0-9][0-9][A-Z][0-9]{4})|([0-9][0-9]BH[0-9]{4}[A-Z]{2})|((^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TN|TS|TR|UA|UK|UP|WB)[0-9]{6}))|((^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TN|TS|TR|UA|UK|UP|WB)[0-9][0-9][A-Z]{3}[0-9]{4})))/;

